import { Network } from 'balancer-labs-sdk-fuji';
import { NativeAsset } from '@/types/TokenList';
import { Ref } from 'vue';
export const POOLS_ROOT_KEY = 'pools';
export const FARM_POOLS_ROOT_KEY = 'poolInfos';
export const BALANCES_ROOT_KEY = 'accountBalances';
export const CLAIMS_ROOT_KEY = 'claims';
export const CLAIMSFLAKE_ROOT_KEY = 'claimsFlake';

const QUERY_KEYS = {
  Pools: {
    All: (
      networkId: Ref<Network>,
      tokens: Ref<string[]>,
      poolIds: Ref<string[]> | undefined
    ) => [POOLS_ROOT_KEY, 'all', { networkId, tokens, poolIds }],
    User: (networkId: Ref<Network>, account: Ref<string>) => [
      POOLS_ROOT_KEY,
      'user',
      { networkId, account }
    ],
    Balancer: (networkId: Ref<Network>) => [
      POOLS_ROOT_KEY,
      'balancer',
      { networkId }
    ],
    Current: (id: string) => [POOLS_ROOT_KEY, 'current', { id }],
    Snapshot: (networkId: Ref<Network>, id: string) => [
      POOLS_ROOT_KEY,
      'snapshot',
      { networkId, id }
    ],
    Activities: (networkId: Ref<Network>, id: string) => [
      POOLS_ROOT_KEY,
      'activities',
      'all',
      { networkId, id }
    ],
    UserActivities: (
      networkId: Ref<Network>,
      id: string,
      account: Ref<string>
    ) => [POOLS_ROOT_KEY, 'activities', 'user', { networkId, account, id }],
    Swaps: (
      networkId: Ref<Network>,
      id: string,
      subgraphQuery: Record<string, any>
    ) => [POOLS_ROOT_KEY, 'swaps', { networkId, id, subgraphQuery }],
    UserSwaps: (networkId: Ref<Network>, id: string, account: Ref<string>) => [
      POOLS_ROOT_KEY,
      'swaps',
      'user',
      { networkId, account, id }
    ]
  },
  FarmPools: {
    All: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'poolInfos',
      { networkId, pid: '1' }
    ],
    User: (networkId: Ref<Network>, account: Ref<string>) => [
      FARM_POOLS_ROOT_KEY,
      'userInfos',
      { networkId, account }
    ],
    UserBasic: (networkId: Ref<Network>, account: Ref<string>) => [
      FARM_POOLS_ROOT_KEY,
      'userInfos',
      { networkId, account, type: 'basic' }
    ],
    FARMINGINFO: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'farmingInfo',
      { networkId, id: '1' }
    ],
    BASEFLAKEINFOS: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'baseFlakeInfos',
      { networkId }
    ],
    FLAKECIRCULATES: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'flakeCirculates',
      { networkId }
    ],
    UserLeaveRequests: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'userLeaveRequests',
      { networkId, id: '1' }
    ],
    UserFlakeInfos: (networkId: Ref<Network>) => [
      FARM_POOLS_ROOT_KEY,
      'userFlakeInfos',
      { networkId, id: '1' }
    ],
    Current: (id: string) => [FARM_POOLS_ROOT_KEY, 'current', { id }]
  },
  TokenLists: {
    All: (networkId: Ref<Network>) => ['tokenLists', 'all', { networkId }]
  },
  LpTokenLists: {
    All: (networkId: Ref<Network>) => ['lpTokenLists', 'all', { networkId }]
  },
  Claims: {
    All: (networkId: Ref<Network>, account: Ref<string>) => [
      CLAIMS_ROOT_KEY,
      { networkId, account }
    ]
  },
  ClaimsFlake: {
    All: (networkId: Ref<Network>, account: Ref<string>) => [
      CLAIMSFLAKE_ROOT_KEY,
      { networkId, account }
    ]
  },
  Tokens: {
    TrendingPairs: (userNetworkId: Ref<number>) => [
      'trendingTradePairs',
      { userNetworkId }
    ],
    PairPriceData: (
      tokenInAddress: Ref<string>,
      tokenOutAddress: Ref<string>,
      activeTimespan: Ref<{ option: string; value: number }>,
      userNetworkId: Ref<number>,
      nativeAsset: NativeAsset,
      wrappedNativeAsset: Ref<NativeAsset>
    ) => [
      'pairPriceData',
      {
        tokenInAddress,
        tokenOutAddress,
        activeTimespan,
        userNetworkId,
        nativeAsset,
        wrappedNativeAsset
      }
    ],
    Prices: (
      networkId: Ref<Network>,
      tokens: Ref<string[]>,
      pricesToInject: Ref<Record<string, number>>
    ) => ['tokens', 'prices', { networkId, tokens, pricesToInject }],
    AllPrices: ['tokens', 'prices']
  },
  Account: {
    Balances: (
      networkId: Ref<Network>,
      account: Ref<string>,
      tokens: Ref<string[]>
    ) => ['account', 'balances', { networkId, account, tokens }],
    Balance: (
      networkId: Ref<Network>,
      account: Ref<string>,
      token: Ref<string>
    ) => ['account', 'balance', { networkId, account, token }],
    Allowances: (
      networkId: Ref<Network>,
      account: Ref<string>,
      contractAddresses: Ref<string[]>,
      tokens: Ref<string[]>
    ) => [
      'account',
      'allowances',
      { networkId, account, contractAddresses, tokens }
    ],
    RelayerApprovals: (
      networkId: Ref<Network>,
      account: Ref<string>,
      relayer: Ref<string>
    ) => ['account', 'relayer', { networkId, account, relayer }],
    Profile: (
      networkId: Ref<Network>,
      account: Ref<string>,
      chainId: Ref<number | undefined>
    ) => ['account', 'profile', { networkId, account, chainId }]
  },
  Gauges: {
    All: () => ['gauges', 'all']
  }
};

export default QUERY_KEYS;
